<template>
  <section class="error-page center">
    <div class="error-page__dialog">
      <svg class="error-page__icon" viewBox="0 0 61.4 69.88" xmlns="http://www.w3.org/2000/svg">
        <path
          d="m28 68.35c-6.19.61-11.36-1.86-15.44-5.65-8.76-8.17-12.51-22.47-10.66-25.4 1.18-1.87 5.66.58 13.48 13.47-8.96-18.33-8.84-28.46-7.38-30.72s4.25 1.48 15.82 24.87c-9.5-24.22-8.08-34.65-6.51-37.55s6.49 4.81 14.91 31.13c-6.31-26.32-1.91-34.88.83-36.87s8.87 12.86 10.75 24.81c3.49 22.27 1 28.85-3.16 28.44-5.33-.52-.35-15.3 2.63-23.57 4.21-11.69 29.47-20.46 8.42 27.29"
          fill="none"
          stroke="#5522fa"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.88"
        />
      </svg>
      <h1 class="error-page__title">The page you were looking for doesn't exist.</h1>
      <p class="error-page__text">You may have mistyped the address or the page may have moved.</p>
      <p></p>
      <p>
        <router-link to="/">Go back home</router-link>
      </p>
    </div>
  </section>
</template>
<script>
export default {
  name: "Error",
  metaInfo: {
    title: "Page not found",
    titleTemplate: "%s | HEY"
  }
};
</script>
